import React from 'react';
import { Webhook } from 'lucide-react';
import { PROVIDER_ICONS } from '@cotera/client/v0/components/tool-connections/constants';
import { cn } from '@cotera/client/v0/lib/utils';

// Keyed by raw webhook provider key. Unknown/`generic` keys fall through to the
// generic webhook icon, so a plain string (e.g. off a trigger list row) is safe.
const WEBHOOK_PROVIDER_LOGO_KEYS: Record<string, keyof typeof PROVIDER_ICONS> =
  {
    hubspot: 'hubspot',
    github: 'github',
    zendesk: 'zendesk',
    telegram: 'telegram',
    linear: 'linear',
    shopify: 'shopify',
    calendly: 'calendly',
    sentry: 'sentry',
    grain: 'grain',
    gong: 'gong',
    lemlist: 'lemlist',
    klaviyo: 'klaviyo',
  };

export const WebhookProviderIcon: React.FC<{
  providerKey: string;
  className?: string;
}> = ({ providerKey, className = 'h-4 w-4' }) => {
  const logoKey = WEBHOOK_PROVIDER_LOGO_KEYS[providerKey];
  if (logoKey === undefined) {
    return <Webhook className={className} />;
  }
  const Logo = PROVIDER_ICONS[logoKey];
  if (Logo === undefined) {
    return <Webhook className={className} />;
  }
  // Brand logos ship at their own intrinsic size; pin the rendered SVG to the
  // icon box (`className` sizes the box) so wide marks like HubSpot/Zendesk
  // don't overflow and overlap neighboring text.
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center [&>svg]:h-full [&>svg]:w-full',
        className
      )}
    >
      <Logo />
    </span>
  );
};
